import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { Link } from 'react-router-dom';
import { readFuncao } from '@/modules/structure/funcao/funcao.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

interface ReadFuncaoDto {
  id: number;
  nome: string;
  editadoPor?: { id: number; nome: string };
  editadoEm?: Date;
}

export default function FuncaoIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadFuncaoDto[], number]>();
  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    readFuncao({
      skip: (tableState.currentPage - 1) * tableState.pageSize,
      take: tableState.pageSize,
      orderBy: tableState.sortConfig.direction,
      orderField: tableState.sortConfig.key,
    }).then((result) => {
      setRegistros(result);
    }).catch((res) => {
      toast.error(String(res) || '');
    });
  };

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Funcao_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  const colunas: Column<ReadFuncaoDto>[] = [
    { key: 'nome', header: 'Nome' },
    {
      key: 'acoes',
      header: 'Ações',
      render: (row) => (
        <Link className="link-secondary" to={Links.Funcao_Editar + '/' + row.id}>
          Editar
        </Link>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-12">
        <h3 className="pt-4">Funções</h3>
        <span className="blockquote-footer pb-4 text-end">
          Funções dos colaboradores.
        </span>
      </div>
      <hr className="pb-4" />

      {registros && (
        <DataTable
          columns={colunas}
          data={registros[0]}
          initialSortKey="nome"
          onChange={handleBuscar}
          serverSide={true}
          states={tableState}
          totalRecords={registros[1]}
        />
      )}
    </div>
  );
}

